module.exports = __webpack_public_path__ + "static/img/0203_01.ba5cce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/0203_01.png
// module id = KMK7
// module chunks = 1